<template>
  <div class="mini-quiz-block quiz-block-with-questions">
    <div v-if="!isStudyGuide" class="mobile-open-quiz hidden">
      <div class="mobile-open-link"></div>
      Quiz
    </div>
    <div class="quiz-main-content" v-bind:class="{show: isStudyGuide}">
      <div class="header_quiz">
        <div class="header-quiz-inner">
          <div class="quiz_points" v-if="!isStudyGuide && loggedIn">
            <div class="points">Points</div>
            <div class="number-points">{{take.score}}</div>
          </div>
          <h2>QUIZ</h2>
          <div class="quiz_indicators_wrapper">
            <ul class="indicators">
              <li class="indicator n1" v-bind:class="{correct: take.question_takes_count > 0}">1</li>
              <li class="indicator n2" v-bind:class="{correct: take.question_takes_count > 1}">2</li>
              <li class="indicator n3">3</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="header_quiz_info">
        <div class="center-block">
          <div id="motivating-message" class="description">Get 3 questions right to see if you've got this concept</div>
        </div>
      </div>

      <div class="content_wrapper">
        <currentQuestion :currentQuestion="currentQuestion"></currentQuestion>
        <div class="content-quiz-buttons buttons">
          <button v-if="!currentQuestionResult" v-bind:disabled="!currentAnswerId" v-bind:class="{disabled: !currentAnswerId}" @click="submitClick" class="w-button first-button quiz-answer-button purple" aria-live="assertive">
            <span>Answer</span>
          </button>
          <button v-if="currentQuestionResult && currentQuestionResult.correct" @click="nextQuestion" class="w-button purple second-button try-next">
            <span>Correct! Next Question</span>
          </button>
          <button v-if="currentQuestionResult && !currentQuestionResult.correct" @click="nextQuestion" class="w-button white second-button try-next incorrect">
            <span>Incorrect! Next Question</span>
          </button>
          <a href="#" v-if="isStudyGuide && !currentQuestionResult" @click="nextQuestion" class="skip">Skip this one</a>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import currentQuestion from "./current_question.vue";
export default {
  name: "QuizTake",
  props: {
    loggedIn: Boolean
  },
  computed: {
    ...mapGetters([
      "take",
      "currentQuestion",
      "currentQuestionResult",
      "currentAnswerId"
    ]),
    ...mapState(["isStudyGuide"])
  },
  components: {
    currentQuestion
  },
  methods: {
    ...mapActions(["nextQuestion", "submitAnswer"]),
    submitClick() {
      this.submitAnswer();
    }
  }
};
</script>
